module.exports = __webpack_public_path__ + "media/images/icons/outlined/sync-a3967048978d5d747a3a14009db71b99.svg";